<template>
  <div>
    <dv-loading v-if="loading" class="loading-container">Loading...</dv-loading>
    <div v-else class="board-container">
      <div class="board-content">
        <div class="content-top">
          <div class="content-top-left">
            <!-- 左侧分为两部分，各占一半 -->
            <div class="left-section">
              <div class="section-title">库区信息</div>
              <div class="store-row" v-for="(item, index) in storeData" :key="`row${index}`">
                <div class="store-item" v-for="(it, ix) in item" :key="`item${ix}`">
                  <div class="store-item-content" :class="{ 'store-item-content--selected': isStoreSelected(it) }">
                    <div class="store-item-content__title" @click="handleToStore(it)">
                      <span>{{ it.title }}</span>
                    </div>
                    <div class="store-item-content__category">
                      <span>分类</span>
                      <span>{{ it.category }}</span>
                    </div>
                    <div class="store-item-content__total">
                      <span>总量</span>
                      <span class="total-value">{{ it.data }}吨</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="left-section">
              <!-- <div class="section-title">库存汇总</div> -->
              <dv-border-box-10>
                <div class="summary-info">
                  <div class="summary-item">
                    <span class="label">期初库存：</span>
                    <span class="value">{{ inOutData.openingQuantityTotal }}吨</span>
                  </div>
                  <div class="summary-item">
                    <span class="label">本月入库：</span>
                    <span class="value" style="color: #00ff00;">{{ inOutData.inQuantityTotal }}吨</span>
                  </div>
                  <div class="summary-item">
                    <span class="label">本月出库：</span>
                    <span class="value" style="color: #ff4d4f;">{{ Math.abs(inOutData.outQuantityTotal) }}吨</span>
                  </div>
                  <div class="summary-item">
                    <span class="label">期末库存：</span>
                    <span class="value">{{ inOutData.endingQuantityTotal }}吨</span>
                  </div>
                </div>
              </dv-border-box-10>
            </div>
          </div>
          <div class="content-top-right">
            <div class="tankRow" v-for="(item, index) in tankData" :key="`tankRow${index}`">
              <div class="tankItem" v-for="(it, ix) in item" :key="`tankItem${ix}`">
                <tank :tankData="it"></tank>
              </div>
            </div>
          </div>
        </div>
        <div class="content-bottom">
          <div class="bottom-left">
            <div class="section-title">预警信息</div>
            <dv-border-box-10>
              <dv-scroll-board :config="warns" ref="scrollBoard" @mouseover.native="handleMouseOver" @mouseleave.native="handleMouseLeave" @click="handleToList">
              </dv-scroll-board>
              <el-tooltip v-model="tooltipVisible"
                placement="right"
                :popper-options="{ positionFixed: true }"
                effect="light"
                :manual="true">
                <div ref="tooltipAnchor2"
                    style="position: absolute; pointer-events: none; opacity: 0"></div>
                <div slot="content" v-html="tooltipContent"></div>
              </el-tooltip>
            </dv-border-box-10>
          </div>
          <div class="bottom-right">
            <dv-border-box-1>
              <in-out-chart :chartData="inOutData"></in-out-chart>
            </dv-border-box-1>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapActions } from 'vuex'
import Tank from './tank'
import InOutChart from '../components/inOutChart'

export default {
  name: 'xnyBoard',
  components: {
    Tank,
    InOutChart
  },
  data () {
    return {
      loading: true,
      timeText: '', // 时间
      weekday: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
      storeData: [],
      tankData: [],
      warns: {
        header: [
          '预警状态',
          '最新预警时间',
          '预警次数'
        ],
        data: [],
        rowNum: 3,
        headerHeight: 30, // 减小表头高度
        headerBGC: '#0f1325',
        align: ['center', 'center', 'center'], // 恢复原始对齐配置
        oddRowBGC: 'rgba(0, 0, 0, 0.1)',
        evenRowBGC: 'rgba(0, 0, 0, 0.1)'
      },
      selectedStore: null,
      inOutData: {
        xAxisData: [],
        monthTotal: new Array(moment().date()).fill(0),
        inQuantity: new Array(moment().date()).fill(0),
        outQuantity: new Array(moment().date()).fill(0),
        endingQuantityTotal: 0,
        inQuantityTotal: 0,
        outQuantityTotal: 0,
        openingQuantityTotal: 0
      },
      timeInterval: null,
      tooltipContent: '',
      tableData: []
    }
  },
  created () { },
  mounted () {
    this.init()
    // 确保不显示滚动条
    this.$nextTick(() => {
      const dom = document.querySelector('.main-view')
      if (dom) {
        dom.style.overflow = 'hidden'
      }
    })
  },
  beforeDestroy () {
    // 清除定时器，避免内存泄漏
    if (this.timeInterval) {
      clearInterval(this.timeInterval)
    }
  },
  methods: {
    ...mapActions(['queryXNYBoardData']),
    timeFn () {
      // 获取时间
      this.updateTime() // 立即更新一次
      this.timeInterval = setInterval(() => {
        this.updateTime()
      }, 1000)
    },
    updateTime () {
      const now = new Date()
      this.timeText = `${now.toLocaleString()} ${this.weekday[now.getDay()]}`
    },
    // 判断是否为选中状态的库区
    isStoreSelected (store) {
      return this.selectedStore && this.selectedStore.title === store.title
    },
    async init (areaCode) {
      this.loading = true
      try {
        this.timeFn()
        const result = await this.queryXNYBoardData({ reservoirAreaType: 'XNYYPK', reservoirAreaCode: areaCode })
        const { data } = result
        if (data) {
          const { reservoirAreaShowList, totalDto, inventoryNumDtoList, storageDayDtoList, oilTankDtoList, warnShows } = data
          // 处理预警数据并赋值给warns.data
          if (Array.isArray(warnShows) && warnShows.length > 0) {
            this.warns.data = warnShows.map(item => [
              `<span style="color: ${item.warnStatus}; font-weight: bold;">${item.warnStatus}</span>`,
              item.warnTime ? moment(item.warnTime).format('YYYY-MM-DD HH:mm:ss') : '-',
              `<span style="color: #06f1ef; font-weight: bold;">${item.warnTotal || 0}</span>`
            ])
            this.tableData = warnShows
          }
          // 库存现有量数据
          if (Array.isArray(inventoryNumDtoList) && inventoryNumDtoList.length > 0) {
            this.iCurrentData = inventoryNumDtoList
          }
          // 储罐数据
          if (Array.isArray(oilTankDtoList) && oilTankDtoList.length > 0) {
            const tankArr = oilTankDtoList
              .map((item) => ({
                name: item.oilTankCode,
                material: item.itemName,
                old: item.openingQuantity || 0,
                new: item.endingQuantity || 0,
                change: item.changeQuantity || 0,
                total: item.oilTankCapacity || 0
              }))
              .filter(tank => tank.new !== 0) // 不展示液位为0的罐
            this.convertTankData(tankArr)
          }
          // 油品库信息
          const areas = []
          for (let i = 0; i < reservoirAreaShowList.length; i++) {
            const titleVal = reservoirAreaShowList[i].name
            const dataVal = reservoirAreaShowList[i].quantity
            const store = { title: titleVal, category: '成品油', data: dataVal }
            areas.push(store)
          }
          this.storeData.push(areas)
          // 出入库数据
          if (Array.isArray(storageDayDtoList) && storageDayDtoList.length > 0) {
            storageDayDtoList.forEach((item) => {
              const { day, endingQuantity, inQuantity, outQuantity } = item
              if (day >= 1 && day <= this.inOutData.monthTotal.length) {
                this.inOutData.monthTotal.splice(day - 1, 1, endingQuantity)
                this.inOutData.inQuantity.splice(day - 1, 1, inQuantity)
                this.inOutData.outQuantity.splice(day - 1, 1, outQuantity)
              }
            })
            this.inOutData.monthTotal = this.inOutData.monthTotal.slice(0, -1)
          }
          // 总量数据
          if (totalDto) {
            const { endingQuantityTotal, inQuantityTotal, outQuantityTotal, openingQuantityTotal } = totalDto
            this.inOutData.endingQuantityTotal = endingQuantityTotal || 0
            this.inOutData.inQuantityTotal = inQuantityTotal || 0
            this.inOutData.outQuantityTotal = outQuantityTotal || 0
            this.inOutData.openingQuantityTotal = openingQuantityTotal || 0
          }
          this.inOutData.xAxisData = this.getInOutXAxis()
        }
      } catch (error) {
        console.error('初始化数据失败:', error)
      } finally {
        this.loading = false
      }
    },
    handleToStore (store) {
      this.storeData = []
      this.inOutData.monthTotal = new Array(moment().date()).fill(0)
      this.inOutData.inQuantity = new Array(moment().date()).fill(0)
      this.inOutData.outQuantity = new Array(moment().date()).fill(0)
      // 如果点击的是已选中的库区，则取消选中
      if (this.selectedStore && this.selectedStore.title === store.title) {
        this.selectedStore = null
        this.init()
      } else {
        this.selectedStore = store
        this.init(this.selectedStore.title)
      }
    },
    getInOutXAxis () {
      const startDate = moment().startOf('month').format('MM/DD') // 当前月的第一天
      const currentDate = moment().subtract(2, 'days').format('MM/DD') // 前一天
      const dateArray = []
      // 循环从第一天到今天
      for (
        let m = moment(startDate);
        m.isSameOrBefore(currentDate);
        m.add(1, 'days')
      ) {
        dateArray.push(m.format('MM/DD'))
      }
      return dateArray
    },
    convertTankData (data) {
      const tankArr = []
      for (let i = 0; i < data.length; i += 3) {
        tankArr.push(data.slice(i, i + 3))
      }
      this.tankData = tankArr
    },
    handleMouseOver (event) {
      this.tooltipVisible = false
      const cell = event.target.closest('.dv-scroll-board .row-item .ceil')
      if (!cell) {
        return
      }
      const statusVal = cell.parentNode && cell.parentNode.children[0].innerText
      if (!statusVal) {
        return
      }
      const rowData = this.tableData.find((item) => item.warnStatus === statusVal)
      if (rowData.warnDetail === null) {
        return
      }
      let count = 0
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].warnStatus === statusVal) {
          count = i + 1
        }
      }
      this.tooltipContent = '预警详情：<br/>'
      rowData.warnDetail.forEach((item) => {
        this.tooltipContent += item.warnType + ':&nbsp;&nbsp;&nbsp;' + item.warnNum + '<br/>'
      })
      this.currentCell = cell
      this.$nextTick(() => {
        const rect = cell.getBoundingClientRect()
        this.$refs.tooltipAnchor2.style.top = `${rect.height * count}px`
        this.$refs.tooltipAnchor2.style.left = `${rect.left - 180}px`
        this.tooltipVisible = true
      })
    },
    handleMouseLeave () {
      this.tooltipVisible = false
    },
    handleToList () {
      this.$router.push({ path: '/warehouseManager/warningHandle' })
    }
  }
}
</script>

<style scoped lang="scss">
.loading-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 23px;
  color: #06f1ef;
  font-weight: bold;
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
}

.board-container {
  background: url('~@/assets/imgs/ydk/bg.png') no-repeat;
  background-size: 100% 100%;
  width: 100%;
  height: 80vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  padding: 15px;
  box-sizing: border-box;
}

.board-header {
    position: relative;
    height: 70px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    .header-title-wrapper {
      text-align: center;
      width: 100%;
    }

    .header-title {
      color: #06f1ef;
      text-align: center;
      font-size: 22px;
      font-weight: bold;
      margin: 5px 0;
    }

    .time-container {
      position: absolute;
      right: 4%;
      top: 50%;
      transform: translateY(-50%);
      background: rgba(0, 31, 63, 0.7);
      padding: 8px 15px;
      border-radius: 5px;
      border: 1px solid #06f1ef;
    }
}

.board-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 15px;
    overflow: hidden;

    .content-top {
        display: grid;
        grid-template-columns: 2fr 3fr;
        gap: 15px;
        flex: 1.7;
        min-height: 0;
        overflow: hidden;
      }

      .content-top-right {
        background: rgba(0, 31, 63, 0.6);
        border: 1px solid #2862b7;
        border-radius: 8px;
        padding: 12px;
        box-sizing: border-box;
        overflow-y: auto; /* 为content-top-right添加垂直滚动条 */
        /* 自定义滚动条样式，适配深色主题 */
        &::-webkit-scrollbar {
          width: 6px; /* 滚动条宽度 */
        }
        &::-webkit-scrollbar-track {
          background: rgba(0, 31, 63, 0.4); /* 滚动条轨道背景色 */
          border-radius: 3px;
        }
        &::-webkit-scrollbar-thumb {
          background: rgba(6, 241, 239, 0.5); /* 滚动条滑块颜色，使用主题色 */
          border-radius: 3px;
          &:hover {
            background: rgba(6, 241, 239, 0.7); /* 滚动条滑块悬停颜色 */
          }
        }

        .section-title {
          color: #06f1ef;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 12px;
          text-align: center;
          padding-bottom: 6px;
          border-bottom: 2px solid #2862b7;
        }
      }

      .content-top-left {
        // 左侧内容使用flex布局，分成两部分
        display: flex;
        flex-direction: column;
        gap: 15px;

        // 左侧每个部分各占一半空间
        .left-section {
          flex: 1;
          background: rgba(0, 31, 63, 0.4);
          border: 1px solid #2862b7;
          border-radius: 6px;
          padding: 12px;
          box-sizing: border-box;
          display: flex;
          flex-direction: column;
        }

        .store-row {
          display: flex;
          flex-wrap: wrap;
          gap: 8px;
          margin-bottom: 8px;

          .store-item {
            width: calc(33.33% - 8px);
            min-height: 100px;

            .store-item-content {
              width: 100%;
              height: 100%;
              display: flex;
              flex-direction: column;
              border: solid 2px #2862b7;
              border-radius: 6px;
              padding: 8px;
              box-sizing: border-box;
              background: rgba(0, 31, 63, 0.4);
              transition: all 0.3s ease;
              cursor: pointer;

              &:hover {
                transform: translateY(-2px);
                box-shadow: 0 4px 12px rgba(6, 241, 239, 0.3);
              }

              .store-item-content__title,
              .store-item-content__category,
              .store-item-content__total {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 6px;
              }

              .store-item-content__title {
                font-size: 16px;
                font-weight: bold;
                color: #06f1ef;
                margin-bottom: 10px;
              }

              .store-item-content__category,
              .store-item-content__total {
                font-size: 12px;
                color: #fff;

                span:first-child {
                  color: #87ceeb;
                }

                .total-value {
                  font-weight: bold;
                  color: #06f1ef;
                }
              }

              // 选中状态的样式
              &--selected {
                border-color: #06f1ef !important;
                box-shadow: 0 0 15px rgba(6, 241, 239, 0.6);
                background: rgba(6, 241, 239, 0.1);
              }
            }
          }
        }

        // 左侧库存汇总样式
        .dv-border-box-10 {
          flex: 1;
          display: flex;
          flex-direction: column;
        }

        .summary-info {
          height: 100%;
          display: flex;
          flex-direction: column;
          padding: 12px;

          .summary-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 12px;
            font-size: 12px;

            .label {
              color: #87ceeb;
            }

            .value {
              color: #06f1ef;
              font-weight: bold;
              font-size: 14px;
            }
          }
        }
      }

      .content-top-right {
        .tankRow {
          display: flex;
          flex-wrap: wrap;
          gap: 10px;
          // justify-content: space-between;

          .tankItem {
            width: calc(33% - 10px);
            min-height: 100px; // 进一步减小高度以适应新的content-top高度
            border: 1px dashed #2862b7;
            border-radius: 6px;
            padding: 6px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: center;

            &:hover {
              border-color: #06f1ef;
            }
          }
        }
      }
    }

    .content-bottom {
        display: grid;
        grid-template-columns: 2fr 3fr;
        gap: 15px;
        flex: 1.02; /* content-top缩小15%后，content-bottom占据更多空间，从原来的flex:1调整为flex:1.15 */
        min-height: 0;
        overflow: hidden;

        .bottom-left,
        .bottom-right {
          height: 100%;
          background: rgba(0, 31, 63, 0.6);
          border: 1px solid #2862b7;
          border-radius: 8px;
          padding: 12px;
          box-sizing: border-box;
          overflow: hidden;

          .section-title {
            color: #06f1ef;
            font-size: 16px;
            font-weight: bold;
            margin-bottom: 12px;
            text-align: center;
            padding-bottom: 6px;
            border-bottom: 2px solid #2862b7;
          }
        }

        .bottom-left {
          .dv-border-box-10 {
            height: calc(100% - 40px);
            display: flex;
            flex-direction: column;
            color: #fff;
          }
          :deep(.dv-scroll-board) {
            height: 100%;
          }
          :deep(.dv-scroll-board .rows .ceil) {
            text-overflow: inherit;
          }
          :deep(.dv-scroll-board-header) {
            background: rgba(0, 31, 63, 0.8) !important;
            color: #06f1ef !important;
            font-weight: bold;
          }
          :deep(.dv-scroll-board-item) {
            background: rgba(0, 31, 63, 0.4) !important;
            color: #fff !important;
          }
          :deep(.dv-scroll-board-item:nth-child(odd)) {
            background: rgba(0, 31, 63, 0.6) !important;
          }

          :deep(.warning-table-container) {
            height: 100%;
            overflow: hidden;
            color: #fff;

            table {
              width: 100%;
              border-collapse: collapse;

              th,
              td {
                padding: 10px;
                text-align: center;
                border-bottom: 1px solid #2862b7;
              }

              th {
                background: rgba(0, 31, 63, 0.8);
                color: #06f1ef;
                font-weight: bold;
                position: sticky;
                top: 0;
                z-index: 10;
              }

              td {
                background: rgba(0, 31, 63, 0.4);
                transition: background-color 0.3s ease;

                &:hover {
                  background: rgba(0, 31, 63, 0.6);
                }
              }
            }

            .status-badge {
              display: inline-block;
              padding: 3px 6px;
              border-radius: 4px;
              font-size: 11px;
              font-weight: bold;

              &.status-pending {
                background: rgba(255, 77, 79, 0.2);
                color: #ff4d4f;
                border: 1px solid #ff4d4f;
              }

              &.status-processed {
                background: rgba(82, 196, 26, 0.2);
                color: #52c41a;
                border: 1px solid #52c41a;
              }
            }
          }

      .summary-info {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 15px;

        .summary-title {
          color: #06f1ef;
          font-size: 16px;
          font-weight: bold;
          margin-bottom: 20px;
          text-align: center;
        }

        .summary-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          font-size: 14px;

          .label {
            color: #87ceeb;
          }

          .value {
            color: #06f1ef;
            font-weight: bold;
            font-size: 16px;
          }
        }
      }
    }
  }

/* 响应式设计 */
@media (max-width: 1400px) {
  .board-container {
    .board-content {
      .content-top,
      .content-bottom {
        grid-template-columns: 1fr;
        height: auto;
      }

      .content-top-right {
        .tankRow {
          .tankItem {
            width: calc(50% - 10px);
          }
        }
      }
    }
  }
}

/* 滚动条样式 */
.main-view {
  overflow: hidden;
}

.main-view::-webkit-scrollbar {
  height: 8px;
}

.main-view::-webkit-scrollbar-track {
  background: rgba(0, 31, 63, 0.2);
  border-radius: 4px;
}

.main-view::-webkit-scrollbar-thumb {
  background: #2862b7;
  border-radius: 4px;
}

.main-view::-webkit-scrollbar-thumb:hover {
  background: #06f1ef;
}

.main-view::-webkit-scrollbar-button {
  background: transparent;
  width: 10px;
}

.main-view::-webkit-scrollbar-corner {
  background: transparent;
}
</style>
